import { isPvmGpsTemplate } from '../69d0c43f5a2b1c0d9e8f7a6b/templateConstants';
import { pvmWebCompact } from '../69d0c43f5a2b1c0d9e8f7a6b/pvmCompactLayout';
import { TEMPLATE_ID_DUAL_SHARE_CLASS, TEMPLATE_ID_OMIT_ETHIK_KONTROVERSE } from './templateConstants';

export function isDualShareCompactLayout(templateId?: string): boolean {
  return templateId === TEMPLATE_ID_DUAL_SHARE_CLASS;
}

/** Value Focus Fund — extra STRATEGIE block on page 1 needs tighter vertical rhythm */
export function isValueFocusCompactLayout(templateId?: string): boolean {
  return templateId === TEMPLATE_ID_OMIT_ETHIK_KONTROVERSE;
}

export function isPage1CompactLayout(templateId?: string): boolean {
  return isDualShareCompactLayout(templateId) || isValueFocusCompactLayout(templateId);
}

export function resolvePage1WebCompact(templateId?: string) {
  if (isPvmGpsTemplate(templateId)) return pvmWebCompact;
  if (isValueFocusCompactLayout(templateId)) return valueFocusWebCompact;
  if (isDualShareCompactLayout(templateId)) return dualShareWebCompact;
  return null;
}

/**
 * Web/PDF spacing for dual share-class — between default and the previous tight pass.
 * Default → compact (old) → this (moderate).
 */
export const dualShareWebCompact = {
  stackSpacing: 16,
  mainGridSpacing: 38,
  introGridSpacing: 16,
  sectionMarginBottom: 14,
  contentTitleMarginBottom: 12,
  contentTitlePaddingBottom: 3,
  contentTitle2MarginBottom: 2,
  contentTitle2PaddingBottom: 2.5,
  contentTextMarginBottom: 6,
  introMargin: '32px 0 14px',
  dualShareRowMarginBottom: 0.35,
  dualShareLineHeight: 1.2,
  lineChartHeight: 242,
  barChartHeight: 212,
  pieChartMarginBottom: 18,
  page2GridSpacing: 38,
  disclaimerMarginTop: 16,
} as const;

/** PDF preview inline gaps (page 1 charts) */
export const dualSharePdfPage1 = {
  chartBlockMarginTop: 7,
  chartImageMarginTop: 4,
  chartPlaceholderMarginTop: 10,
  contentHeaderMarginBottom: 1.5,
} as const;

/** Web preview spacing — Value Focus (6995ed83…) */
export const valueFocusWebCompact = {
  stackSpacing: 14,
  mainGridSpacing: 34,
  introGridSpacing: 14,
  sectionMarginBottom: 11,
  contentTitleMarginBottom: 10,
  contentTitlePaddingBottom: 2.5,
  contentTitle2MarginBottom: 1.5,
  contentTitle2PaddingBottom: 2,
  contentTextMarginBottom: 4,
  introMargin: '28px 0 12px',
  lineChartHeight: 238,
  barChartHeight: 208,
  pieChartMarginBottom: 16,
  page2GridSpacing: 36,
  disclaimerMarginTop: 14,
} as const;

/** PDF preview inline gaps — Value Focus */
export const valueFocusPdfPage1 = {
  chartBlockMarginTop: 6,
  chartImageMarginTop: 3.5,
  chartPlaceholderMarginTop: 9,
  contentHeaderMarginBottom: 1,
} as const;
